import { INSTA_ONLINE_FOLLOWER } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instaOnlineFollowersData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case INSTA_ONLINE_FOLLOWER:
     
      // const parsedData = JSON.parse(action.payload.data)
      
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}